// @flow
import * as React from 'react';
import Dialog from 'material-ui/Dialog';
import styled, { withTheme } from 'styled-components';

const Header = styled.div`
  flex: 1;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  background-color: ${({ theme }) => theme.colors.primary};
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.tertiaryText};
  font-size: ${({ theme }) => theme.fonts.style.sub.fontSize}px;
`;

const Icon = styled(Title)`
  font-size: ${({ theme }) => theme.fonts.style.secondary.fontSize}px;

  :hover {
    cursor: pointer;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

type Props = {
  visible: boolean;
  onClose: () => any;
  children: any;
  theme: Object;
  title: string;
}

const FolloDialog = ({ visible, onClose, title, children, theme, ...rest }: Props) => {
  return (
    <Dialog
      {...rest}
      open={visible}
      onRequestClose={onClose}
      modal={false}
      bodyStyle={{ padding: 0 }}
      autoScrollBodyContent
      title={
        <Header>
          <Title>{title}</Title>
          <Icon onClick={onClose} className="material-icons">close</Icon>
        </Header>
      }
      titleStyle={{
        paddingTop: theme.metrics.smallMargin,
        paddingBottom: theme.metrics.smallMargin,
        paddingLeft: theme.metrics.largeMargin,
      }}
    >
      <ContentWrapper>
        {children}
      </ContentWrapper>
    </Dialog>
  );
};

export default withTheme(FolloDialog);



// WEBPACK FOOTER //
// ./src/advertisers/components/FolloDialog.js